import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NgxPaginationModule} from 'ngx-pagination';
import {SharedModule} from '../../../../shared/shared/shared.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ModalModule} from 'ngx-bootstrap';
import {NgSelectModule} from '@ng-select/ng-select';
import {OfferDetailsComponent} from './offer-details.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgxPaginationModule,
    NgSelectModule,
    SharedModule,
    ReactiveFormsModule,
    ModalModule,
  ],
  declarations: [
    OfferDetailsComponent,
  ]
})
export class OfferDetailsModule {
}
